import { buildCurrentUnderstandingFull, getUserConditions } from "../self-assesment2/generatePayloadForScreen";

/* eslint-disable no-unused-vars */
const subDomain = (window.location.host === "www.myptmyra.com" || window.location.host === "myptmyra.com" || window.location.host === "www.startfreept.com" ||
    window.location.host === "startfreept.com" ||
    window.location.host === "virdiohealth.com" ||
    window.location.host === "www.virdiohealth.com")
    ? "api" : "uatapi";

const CHAT_API_URL = `https://${subDomain}.virdiohealth.com/api/v1/assessment/chat`;

function cleanMyraResponseText(response) {
    if (typeof response !== 'string') return response;

    const trimmed = response.trim();
    if (!trimmed) return response;

    if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
        try {
            const parsed = JSON.parse(trimmed);
            if (typeof parsed === 'string') return parsed;
            if (Array.isArray(parsed)) {
                const first = parsed[0];
                if (typeof first === 'string') return first;
                if (first && typeof first === 'object') return first.response || first.text || first.ack || response;
            }
            if (parsed && typeof parsed === 'object') {
                return parsed.response || parsed.text || parsed.ack || response;
            }
        } catch (error) {
            const malformedSingleString = trimmed.match(/^\{\s*"([\s\S]*?)"\s*\}$/);
            if (malformedSingleString?.[1]) {
                return malformedSingleString[1]
                    .replace(/\\n/g, '\n')
                    .replace(/\\t/g, ' ')
                    .replace(/\\"/g, '"')
                    .trim();
            }
        }
    }
    const malformKeyValue = trimmed.match(/^"?\w+"?\s*:\s*"([\s\S]*?)"?\s*$/);
    if (malformKeyValue?.[1]) {
        return malformKeyValue[1]
            .replace(/\\n/g, '\n')
            .replace(/\\t/g, ' ')
            .replace(/\\"/g, '"')
            .trim();
    }

    const leadingBracedToken = trimmed.match(/^\{[^{}]+\}([\s\S]*)$/);
    if (leadingBracedToken) {
        return leadingBracedToken[1].trim();
    }

    return response;
}

const MyraChatService = {
    /**
     * Send a user message and get Myra's response.
     * @param {string} userMessage - The text the user typed
     * @param {string} sessionId - The analytics session ID (window.trSessionId)
     * @param {Array} conversationHistory - Array of {role, content} objects for context
     * @param {number} turnNumber - The current turn number in the conversation
     * @returns {Promise<{response: string, conversationHistory: Array}>}
     */
    sendMessage: async (userMessage, sessionId, conversationHistory = [], turnNumber, screenPayload = {}, screenName = "", options = {}) => {
        const flow = window.currentFlow || window.VoiceService._currentFlow || "unknown_flow"
        let symptomType = false;
        let romChange = "";
        let tempoChange = "";
        let data_source = "";
        let whats_next = "";
        let rpe = 0;
        let painLocations = []
        let symptomDuration = ""
        let preTestNPRS = 0
        const userName = window.localStorage.getItem("self_name") || ""
        if (window?.flowSymptomPayload) {
            symptomType = window?.flowSymptomPayload?.symptomType;
            romChange = window?.flowSymptomPayload?.romChange;
            tempoChange = window?.flowSymptomPayload?.tempoChange;
            data_source = window?.flowSymptomPayload?.data_source;
            whats_next = window?.flowSymptomPayload?.whats_next;
            preTestNPRS = window?.flowSymptomPayload?.preTestNPRS;
            symptomDuration = window?.flowSymptomPayload?.symptomDuration;
            rpe = window?.flowSymptomPayload?.rpe;
            painLocations = window?.flowSymptomPayload?.painLocations;
        }
        try {
            const gsaStep = screenPayload?.gsa_step || screenName;
            const assessmentData = localStorage.getItem("assessmentData") ? JSON.parse(localStorage.getItem("assessmentData")) : {};
            const activePromptStorageKey = `myraRouterActivePrompt:${sessionId || "default"}`;
            const storedActivePrompt = localStorage.getItem(activePromptStorageKey);
            const activePrompt = options.active_prompt !== undefined
                ? options.active_prompt
                : (storedActivePrompt && storedActivePrompt !== "null" ? storedActivePrompt : null);
            const payload = {
                session_id: sessionId,
                message: userMessage,
                conversation_history: conversationHistory,
                turnNumber: turnNumber || 0,
                source: gsaStep,
                timestamp: new Date().toISOString(),
                screenPayload: screenPayload,
                active_prompt: activePrompt,
                ...(options.router_followup === true && { router_followup: true }),
                flow: flow,
                userName: userName,
                input_mode: window?.MyraInteraction?.getMode() || 'chat',
                ...(flow === "flow_symptom" && {
                    symptomType,
                    romChange,
                    tempoChange,
                    whats_next,
                    data_source,
                    preTestNPRS,
                    symptomDuration,
                    rpe,
                    painLocations,
                    current_understanding: buildCurrentUnderstandingFull(assessmentData),
                    user_conditions: getUserConditions(),
                })
            };


            const MAX_RETRIES = 2;
            const RETRY_DELAY_MS = 1500;

            let response;
            let lastError = null;

            for (
                let attempt = 0;
                attempt <= MAX_RETRIES;
                attempt++
            ) {
                try {
                    console.log("Sending chat payload:", payload);
                    if (attempt > 0) {
                        console.warn(
                            `[MyraChatService] Retry ${attempt}/${MAX_RETRIES}`
                        );

                        await new Promise((resolve) =>
                            setTimeout(
                                resolve,
                                RETRY_DELAY_MS
                            )
                        );
                    }

                    response = await fetch(CHAT_API_URL, {
                        method: "POST",
                        headers: {
                            "Content-Type":
                                "application/json",
                        },
                        body: JSON.stringify(payload),
                    });

                    if (!response.ok) {
                        throw new Error(
                            `HTTP ${response.status}`
                        );
                    }

                    break;
                } catch (error) {
                    lastError = error;

                    console.error(
                        `[MyraChatService] Attempt ${attempt + 1
                        } failed:`,
                        error
                    );

                    if (attempt === MAX_RETRIES) {
                        throw lastError;
                    }
                }
            }

            const data = await response.json();
            console.log("Received chat response:", data);
            if (Object.prototype.hasOwnProperty.call(data || {}, "active_prompt")) {
                localStorage.setItem(activePromptStorageKey, data.active_prompt === null || data.active_prompt === undefined ? "null" : data.active_prompt);
            }
            const action = data?.data?.action || data?.action || null;
            let value = data?.data?.value || data?.value || null;
            // const speech = data?.response || "";
            const intent = data?.data?.intent || data?.intent || null;
            const moveAction = data?.MoveAction || null;
            const extracted = data?.data?.extracted || data?.extracted || null;
            const speech = data?.data?.speech || data?.speech || "";
            const actions = data?.data?.actions || data?.actions || null;
            let actionValue = data?.data?.actionValue || data?.actionValue || null;
            const matched = data?.data?.matched || data?.matched || null;

            if (window.MyraInteraction.getCurrentScreen() === "nprs_symptoms") {
                if (action === "SELECT_PAIN_LEVEL" && moveAction === true && !value && !actionValue && matched === "classifier") {
                    value = 0
                    actionValue = 0
                }
            }

            window._lastCommandAction = action;
            const shouldAutoExecuteCommand = flow !== "flow_plan_v2";
            if (shouldAutoExecuteCommand && action && window.currentCommandsAudio?.[action]) {
                const now = Date.now();
                if (now - (MyraChatService._lastCallTime || 0) > 500) {
                    console.log(`[CHAT] Executing command handler: ${action}`);
                    window.currentCommandsAudio[action](value, speech, intent, extracted, actionValue, actions, matched);
                    MyraChatService._lastCallTime = now;
                } else {
                    console.log('[CHAT] Too fast call, skipping');
                }
            }
            if (window.MyraInteraction.getCurrentScreen() === "intro") {
                window.landingHistory = data.history || []
            }

            const responseText = cleanMyraResponseText(data.response);
            return {
                response: responseText,
                moveAction: moveAction ? true : false,
                action: action,
                actions: actions,
                actionValue: actionValue,
                matched: matched,
                value: data.value,
                speech: speech,
                conversationHistory: data.history,
                intent: intent || data.intent || null,
                extracted: extracted,
                conditions: data.conditions || null,
                turnNumber: data.turnNumber || 0,
                history: data.history || [],
                bucket_state: data.bucket_state || data?.data?.bucket_state || null,
                active_prompt: Object.prototype.hasOwnProperty.call(data || {}, "active_prompt") ? data.active_prompt : data?.data?.active_prompt,
                router_signal: data.router_signal || data?.data?.router_signal || null,
                _router: data._router || null,
                screenPayload: data.screenPayload || null,
            };
        } catch (error) {
            console.error("MyraChatService.sendMessage Error:", error);
            return {
                response: "I'm having trouble connecting right now. You can try again, or tap the mic to talk to me instead.",
                conversationHistory,
            };
        }
    },
};

export default MyraChatService;